import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  TextField
} from '@material-ui/core';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    divider: {
      margin: theme.spacing(1.5, 0)
    },
    ul: {
      paddingLeft: theme.spacing(3)
    },
    textArea: {
      whiteSpace: 'pre-wrap'
      //To prevent collapse multiple consecutive spaces into a single space by default
    },
    flexAction: {
      display: 'flex',
      '& > *': {
        margin: theme.spacing(1)
      },
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column-reverse',
        width: `calc(100% - ${theme.spacing(2)}px)`,
        '& > *': {
          marginTop: 0
        }
      }
    },
    redColor: {
      backgroundColor: theme.palette.error.main,
      '&:hover, &.Mui-focusVisible': {
        backgroundColor: theme.palette.error.dark
      }
    }
  })
);

interface ConfirmDeleteProps {
  open: boolean;
  text?: string;
  onCloseDelete: () => void;
  onDelete: () => void;
  additionalDisabled?: boolean;
  children?: React.ReactNode;
}

export default function ConfirmDelete({
  open,
  text = '',
  onCloseDelete,
  onDelete,
  additionalDisabled = false,
  children
}: ConfirmDeleteProps) {
  const classes = useStyles();
  const { t } = useTranslation();

  const [textConfirm, setTextConfirm] = useState<string>('');

  function onCloseDeleteAndSetTextConfirm() {
    onCloseDelete();
    setTextConfirm('');
  }

  function onConfirmDeleteAndSetTextConfirm() {
    onDelete();
    setTextConfirm('');
  }

  return (
    <div>
      <Dialog
        fullWidth
        maxWidth="sm"
        open={open}
        onClose={onCloseDeleteAndSetTextConfirm}
      >
        <DialogTitle id="title">{t('confirmDelete.title')}</DialogTitle>
        <DialogContent>
          <DialogContentText id="description" color="textPrimary">
            {t('confirmDelete.description', { itemName: text })}
          </DialogContentText>
          <Divider className={classes.divider} />
          {children}
          <DialogContentText id="description">
            {t('confirmDelete.instruction')}
          </DialogContentText>
          <ul className={classes.ul}>
            <li>
              <span className={classes.textArea}>
                <b>{text}</b>
              </span>
            </li>
          </ul>
          <TextField
            variant="outlined"
            color="primary"
            size="small"
            fullWidth
            value={textConfirm}
            onChange={(event) => setTextConfirm(event.target.value)}
            placeholder={t('confirmDelete.placeholder') as string}
            required
          />
        </DialogContent>
        <div className={classes.flexAction}>
          <Button
            className={classes.redColor}
            fullWidth
            color="primary"
            variant="contained"
            disabled={text !== textConfirm || text === '' || additionalDisabled}
            onClick={onConfirmDeleteAndSetTextConfirm}
          >
            {t('confirmDelete.buttons.delete')}
          </Button>
          <Button fullWidth onClick={onCloseDeleteAndSetTextConfirm}>
            {t('confirmDelete.buttons.cancel')}
          </Button>
        </div>
      </Dialog>
    </div>
  );
}
